import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { toSignal } from '@angular/core/rxjs-interop';
import { BusinessFeeSettingsFirestorePaths } from '../../business-finances-general/business-finances-general.types';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { BaseBusinessSettingsSection } from '../../business-finances-general/common/base-business-settings-section/base-business-settings-section.directive';
import { TestHooks } from './assyst-fee.hooks';

@Component({
	selector: 'app-assyst-fee',
	templateUrl: './assyst-fee.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AssystFeeComponent extends BaseBusinessSettingsSection {
	testHooks = TestHooks;
	private businessDispatch = inject(BusinessDispatch);

	public assystSettingsSignal = toSignal(
		inject(Store).select(BusinessState.getAssystFeeSettings),
	);

	public firestoreDefaultSettingsPath =
		BusinessFeeSettingsFirestorePaths.Assyst;

	public directionOfFeeType = DirectionOfFeeType;

	setAmount(amount: number): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${this.firestoreDefaultSettingsPath}.amount`,
			amount,
		);
	}

	setHst(isHst: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${this.firestoreDefaultSettingsPath}.hst`,
			isHst,
		);
	}
}
